export default __webpack_public_path__ + "static/mar-bote-6567fe30d9692ed1c9be9fdf57ce6611.jpg";